import {
  UserGroupDataQualityIssueType,
  UserGroupDataQualityIssueTypeLabels,
  type UserGroupListApiData
} from '@navio/nsdk';
import type { FilterOption } from 'noddi-ui-web';
import { entriesToOptions } from 'noddi-util';

const DATA_QUALITY_ISSUE_TYPE_FILTER_OPTIONS: FilterOption<UserGroupDataQualityIssueType>[] = entriesToOptions(
  UserGroupDataQualityIssueType,
  UserGroupDataQualityIssueTypeLabels
);

/** Title and description of the "Has data quality issues" boolean, for `unit.boolean('hasDataQualityIssues', ...)`. */
export const HAS_DATA_QUALITY_ISSUES_FILTER_TEXT = {
  title: 'Has data quality issues',
  description: 'Show customers with or without booking-critical data-quality issues.'
};

/** The issue types multi-select, for `unit.multiSelect('dataQualityIssueTypes', { ...it, exclude: true })`. */
export const DATA_QUALITY_ISSUE_TYPES_FILTER = {
  title: 'Data quality issue types',
  description: 'Filter by specific booking-critical customer data-quality issues.',
  options: DATA_QUALITY_ISSUE_TYPE_FILTER_OPTIONS
};

export type UserGroupDataQualityFilterInput = Pick<
  NonNullable<UserGroupListApiData['query']>,
  'dataQualityIssueTypes' | 'excludedDataQualityIssueTypes' | 'hasDataQualityIssues'
>;
